import { render, staticRenderFns } from "./foodCategory.vue?vue&type=template&id=18ba8a7a&scoped=true"
import script from "./foodCategory.vue?vue&type=script&lang=js"
export * from "./foodCategory.vue?vue&type=script&lang=js"
import style0 from "./foodCategory.vue?vue&type=style&index=0&id=18ba8a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba8a7a",
  null
  
)

export default component.exports